export const SET_PREDICTIVE_ROUTING = 'SET_PREDICTIVE_ROUTING';
export const ADD_PREDICTIVE_ROUTING_CONFIG = 'ADD_PREDICTIVE_ROUTING_CONFIG';
export const REPLACE_PREDICTIVE_ROUTING_CONFIG = 'REPLACE_PREDICTIVE_ROUTING_CONFIG';
export const SET_PREDICTIVE_ROUTING_CONFIG_REFERENCES = 'SET_PREDICTIVE_ROUTING_CONFIG_REFERENCES';